export function getContactWarning(overdueDays, targetedTotalIncreased, isolationIncreased, unseenDays) {
    if ((overdueDays && overdueDays > 0 ) || (targetedTotalIncreased) || (isolationIncreased)
            || (unseenDays && unseenDays > 0)) {
        return true;
    }
    return false;
}

export function getContactOverdueOnly(overdueDays, targetedTotalIncreased, isolationIncreased) {
    if ((overdueDays && overdueDays > 0 ) && !targetedTotalIncreased && !isolationIncreased) {
        return true;
    }
    return false;
}

export function getContactSort(contactId, overdueDays, targetedTotalIncreased, isolationIncreased, unseenDays) {
    let sortIndex = 0;
    if (contactId) {
        sortIndex = 1; 
        sortIndex += targetedTotalIncreased ? 2 : 0;
        sortIndex += isolationIncreased ? 2 : 0;
        sortIndex += (overdueDays && overdueDays > 0) ? 2 : 0;
    } else {
        if (unseenDays && unseenDays > 0) {
            sortIndex = 2; 
        }
    }
    return sortIndex;
}

export function getContactWarningTooltip(contactId, unseenDays, overdueDays, targetedTotalIncreased, isolationIncreased) {
    let tooltipContent = [];
    
    if (contactId == null) {
        if (unseenDays && unseenDays > 0) {
            tooltipContent.push("No contact since targeted " + unseenDays + " day" + (unseenDays > 1 ? "s" : "") + " ago");
        } else {
            return null;
        }
    } else {
        tooltipContent = [
            ... (overdueDays > 0) ? [`Follow-up overdue by ${overdueDays} day${overdueDays === 1 ? '' : 's'}`] : [],
            ... (targetedTotalIncreased) ? ['Targeted total has increased'] : [],
            ... (isolationIncreased) ? ['Isolation has increased'] : []
        ];

        if (tooltipContent.length === 0) {
            return null;
        }
    }

    return {tooltipLines: tooltipContent};
}